export function nullFieldsToUndefined(obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
        var _a;
        result[key] = ((_a = obj[key]) !== null && _a !== void 0 ? _a : undefined);
    });
    return result;
}
/**
 * Note: This helper does not convert implicit `undefined` (missing fields) to `null`
 */
export function undefinedFieldsToNull(obj) {
    const result = {};
    Object.keys(obj).forEach((key) => {
        var _a;
        result[key] = ((_a = obj[key]) !== null && _a !== void 0 ? _a : null);
    });
    return result;
}
export function isNil(value) {
    return value === null || value === undefined;
}
export function notNil(value) {
    return !isNil(value);
}
//# sourceMappingURL=nil.js.map